import { HStack, Link, Text } from '@chakra-ui/react';

import React from 'react';

const ManualLink: React.FC<{
  link: string | undefined;
  name: string;
  index: number;
  total: number;
}> = ({ link, name, index, total }) => {
  return (
    <HStack spacing={0}>
      <Link href={link} target='_blank' rel='noreferrer' className='font-bold underline'>
        {name}
      </Link>
      <Text>{index === (total - 1) ? '' : ', '}</Text>
    </HStack>
  );
};

export default ManualLink;
